import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {BaseEntity} from "../base-entity.model";

@BasicEntity({
    name: 'Comentario revisión de blenders',
    endpoint: 'comentario_revision_blenders',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ComentarioRevisionBlender"
})
export class ComentarioRevisionBlender extends BaseEntity {

    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    public static readonly BLENDER_MAP: PropertyMap = {
        name: 'Blender',
        type: PropertyType.FutureUri('blender.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ComentarioRevisionBlender.BLENDER_MAP)
    private _blender;

    @BasicProperty({
        name: 'Comentario',
        type: PropertyType.Text()
    })
    private _comentario;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get blender() {
        return this._blender;
    }

    set blender(value) {
        this._blender = value;
    }

    get comentario() {
        return this._comentario;
    }

    set comentario(value) {
        this._comentario = value;
    }
}
